import React, {useCallback, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG, regions} from '../../../../../../_metronic/helpers'
import {useDispatch, useSelector} from 'react-redux'
import {freeCreditToUser} from '../UserProfileDetailSlice/UserProfileDetailSlice'
import {ACCOUNT_TYPE, REGION_ARRAYS} from '../../../../../Utils/Constant/ConstantForWebsite'
import Select from 'react-select'
import {
  useAllocateCreditMutation,
  usePricingRulesMutation,
} from '../../../../../../services/cellcast.v3'
import {
  AllocateCreditMode,
  CampType,
  PaymentPricingRules,
} from '../../../../../../services/cellcast.v3.types'
import {toast} from 'react-toastify'

const AddCreditPopup = ({show, handleClose}: any) => {
  const dispatch = useDispatch()
  const UserProfileData = useSelector((state: any) => state?.ProfileData?.ProfileData?.user)

  const priceRateData = useSelector((state: any) => state?.priceRules?.RateCardList)
  const PriceRate = Array.isArray(priceRateData) ? priceRateData : []

  const isPostPaid = UserProfileData?.accountType === ACCOUNT_TYPE.POSTPAID

  const [allocateCredit, {isLoading: allocateCreditLoading}] = useAllocateCreditMutation()
  const [fetchPricingRules, {data: RateCardList, isLoading: RateCardListLoading}] =
    usePricingRulesMutation()

  const [quickSms, setQuickSms] = useState('sms')
  const [price, setPrice] = useState(0)
  const [credit, setCredit] = useState<any>(0)
  const [region, setRegion] = useState<any>(REGION_ARRAYS[0].value)
  const [note, setNote] = useState<any>('')

  useEffect(() => {
    if (REGION_ARRAYS[0].value !== region) {
      fetchPricingRules({
        action: 'find_pricing_rules',
        data: {
          accountId: UserProfileData?.accountId,
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [region])

  useEffect(() => {
    if ((REGION_ARRAYS[0].value !== region && !RateCardListLoading) || credit > 0) {
      const PriceRateListSMS = RateCardList?.data?.filter(
        (key: PaymentPricingRules) => key?.Type === CampType.sms.toUpperCase()
      )
      const PriceRateListMMS = RateCardList?.data?.filter(
        (key: PaymentPricingRules) => key?.Type === CampType.mms.toUpperCase()
      )

      if (quickSms === CampType.sms) {
        if (PriceRateListSMS && PriceRateListSMS?.length === 0) {
          setPrice(0)
        } else {
          let rate = PriceRateListSMS?.find(
            (key: PaymentPricingRules) =>
              key?.CreditStartRange >= credit && credit <= key?.CreditEndRange
          )

          if (rate) {
            setPrice(rate?.FinalPrice || 0)
          } else {
            setPrice(0)
          }
        }
      } else {
        if (PriceRateListMMS && PriceRateListMMS?.length === 0) {
          setPrice(0)
        } else {
          let rate = PriceRateListMMS?.find(
            (key: PaymentPricingRules) =>
              key?.CreditStartRange >= credit && credit <= key?.CreditEndRange
          )

          if (rate) {
            setPrice(rate?.FinalPrice || 0)
          } else {
            setPrice(0)
          }
        }
      }
    }
  }, [RateCardList, RateCardListLoading, credit, quickSms, region])

  useEffect(() => {
    if (REGION_ARRAYS[0].value !== region) {
      return
    }

    let sms = PriceRate?.filter((key: any) => key?.type == 'SMS')
    let mms = PriceRate?.filter((key: any) => key?.type == 'MMS')

    if (quickSms == 'sms') {
      let price =
        sms?.find(
          (key: any) => key?.creditendrange >= +credit && key?.creditstartrange <= +credit
        ) == undefined
          ? sms?.find(
              (key: any) =>
                key?.creditendrange === Math.max(...sms.map((o: any) => o?.creditendrange))
            )?.finalPrice
          : sms?.find(
              (key: any) => key?.creditendrange >= +credit && key?.creditstartrange <= +credit
            )?.finalPrice
      if (price) {
        setPrice(price)
      }

      if (isPostPaid && UserProfileData?.postPaidLimitConfig?.smsFlatRatePrice > 0) {
        setPrice(UserProfileData?.postPaidLimitConfig?.smsFlatRatePrice)
      }
    } else {
      let price =
        mms?.find(
          (key: any) => key?.creditendrange >= +credit && key?.creditstartrange <= +credit
        ) == undefined
          ? mms?.find(
              (key: any) =>
                key?.creditendrange === Math.max(...mms.map((o: any) => o?.creditendrange))
            )?.finalPrice
          : mms?.find(
              (key: any) => key?.creditendrange >= +credit && key?.creditstartrange <= +credit
            )?.finalPrice
      if (price) {
        setPrice(price)
      }

      if (isPostPaid && UserProfileData?.postPaidLimitConfig?.mmsFlatRatePrice > 0) {
        setPrice(UserProfileData?.postPaidLimitConfig?.mmsFlatRatePrice)
      }
    }
  }, [quickSms, credit, UserProfileData?.postPaidLimitConfig, PriceRate, isPostPaid, region])

  const SubmmitFreeCreadit = useCallback(() => {
    if (region === REGION_ARRAYS[0].value) {
      dispatch(
        freeCreditToUser({
          userId: UserProfileData?._id,
          noOfCredit: credit,
          campType: quickSms,
          pricePerCredit: price,
          note: note,
        })
      )

      setNote('')
      setCredit(0)
      return
    }

    let balance_type: CampType
    if (quickSms === 'sms') {
      balance_type = CampType.sms
    } else {
      balance_type = CampType.mms
    }

    let allocateCreditAmount = credit
    if (typeof credit === 'string') {
      allocateCreditAmount = parseInt(credit)
    }

    allocateCredit({
      body: {
        action: 'allocate_credit',
        data: {
          balance_type: balance_type,
          cents_per_sms: price,
          credit: allocateCreditAmount,
          mode: AllocateCreditMode.add,
          target_user_id: UserProfileData?._id,
        },
      },
      region: region,
    })
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)
          setNote('')
          setCredit(0)
        } else if ('error' in res) {
          const errObj = res.error as any
          toast.error(errObj.data.message)
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
  }, [UserProfileData?._id, credit, price, quickSms, region, note])

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header border-bottom'>
          <h2>Add credits</h2>
          <div className='btn btn-icon btn-sm' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body p-20 pb-15'>
          <div className='row mb-2'>
            <div className='border-end pe-15'>
              <div className='d-flex gap-4'>
                <div>
                  <input
                    type='radio'
                    className='btn-check'
                    name='sms'
                    checked={quickSms == 'sms'}
                    id='quick_sms_radio2'
                    onClick={() => {
                      setQuickSms('sms')
                    }}
                  />
                  <label className='btn btn-light-info py-2 px-5' htmlFor='quick_sms_radio2'>
                    <span className='fw-500 fs-2'>SMS</span>
                  </label>
                </div>
                <div>
                  <input
                    type='radio'
                    className='btn-check'
                    name='mms'
                    checked={quickSms == 'mms'}
                    id='quick_mms_radio2'
                    onClick={() => {
                      setQuickSms('mms')
                    }}
                  />
                  <label
                    className='btn btn-active-info btn-light-info py-2 px-5'
                    htmlFor='quick_mms_radio2'
                  >
                    <span className='fw-500 fs-2'>MMS</span>
                  </label>
                </div>
              </div>
              <div className='mt-7 mb-10'>
                <label className=' col-form-label fw-normal fs-6'>Choose region</label>
                <Select
                  options={REGION_ARRAYS}
                  value={regions?.find((key: any) => key?.value === region)}
                  onChange={(e: any) => setRegion(e?.value)}
                  className='form-select form-select-solid form-select-lg'
                />
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block text-danger'></div>
                </div>
              </div>
              <div className='mt-7'>
                <label className=' col-form-label fw-normal fs-6'>
                  How many credits should be added?
                </label>
                <input
                  onChange={(e: any) => setCredit(e.target.value)}
                  name='Type'
                  type='text'
                  className='form-control form-control-lg form-control-solid mb-4 w-100 text-bg-light d-block'
                />
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block text-danger'></div>
                </div>
              </div>
              <div className='mt-7'>
                <label className=' col-form-label fw-normal fs-6'>Price per credit</label>
                <input
                  onChange={(e: any) => setPrice(e.target.value)}
                  name='Price Per credit'
                  type='text'
                  value={price}
                  className='form-control form-control-lg form-control-solid mb-4 w-100 text-bg-light d-block'
                />
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block text-danger'></div>
                </div>
              </div>
              <div className='mt-7'>
                <label className=' col-form-label fw-normal fs-6'>Note</label>
                <input
                  onChange={(e: any) => setNote(e.target.value)}
                  value={note}
                  name='Note'
                  type='input'
                  className='form-control form-control-lg form-control-solid mb-4 w-100 text-bg-light d-block'
                />
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block text-danger'></div>
                </div>
              </div>
            </div>
            {/* <div className='col-5 ps-10'>
              <h4 className='mb-4'>Total cost</h4>
              <h1 className='text-info fs-3qx fw-boldest'>$1000</h1>
              <div className='fs-6 text-gray-500'>or 0,34/message</div>
            </div> */}
            <div className='d-flex flex-center mt-20'>
              <div id='kt_drawer_chat_close'>
                <button
                  type='button'
                  onClick={handleClose}
                  className='btn btn-light text-hover-white rounded btn-active-primary me-3 w-100px p-3 fw-500 me-2'
                >
                  Discard
                </button>
              </div>

              <button
                disabled={isNaN(credit) || credit == 0 || credit == ''}
                type='submit'
                className='btn btn-light btn-primary fw-500 rounded  w-100px p-3 border border-primary'
                onClick={() => {
                  SubmmitFreeCreadit()
                  handleClose()
                }}
              >
                <span className='indicator-label'>
                  {allocateCreditLoading ? 'Processing' : 'Submit'}
                </span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default AddCreditPopup
